module.exports = __webpack_public_path__ + "img/access-control-solutionimg-1.2a0986d5.png";